<template>
  <g>
    <path
      d="M9 20.0002C13.4183 20.0002 17 16.4185 17 12.0002C17 7.5819 13.4183 4.00018 9 4.00018C4.58172 4.00018 1 7.5819 1 12.0002C1 16.4185 4.58172 20.0002 9 20.0002Z"
    />
    <path
      d="M17 5.55017V5.73017C17 6.10017 17.23 6.42017 17.57 6.58017C19.6 7.54017 21 9.61017 21 12.0002C21 14.3902 19.6 16.4602 17.57 17.4202C17.23 17.5802 17 17.8902 17 18.2602V18.4402C17 19.1202 17.71 19.5502 18.32 19.2602C21.08 18.0102 23 15.2302 23 12.0002C23 8.77017 21.08 5.99017 18.32 4.73017C17.71 4.45017 17 4.87017 17 5.55017Z"
    />
  </g>
</template>
